import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Inject} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RequestBase } from '../../base/request-base';
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import * as AppConst from '../../data/test.data';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { UrlParams } from '../../helpers/url-params';
import { SelectEventArgs } from '@syncfusion/ej2-angular-dropdowns';
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Component({
    selector: 'requests-inprogress',
    templateUrl: './requests-all.html',
})
export class RequestsInProgressComponent extends RequestBase implements OnInit, OnDestroy {
    dateFormat: string = 'dd/MM/yyyy';
    nameValueFields: Object = { text: 'Name', value: 'Value' };
    constructor(auth: AuthenService, http: HttpService, httpClient: HttpClient, helper: HelperService, notify: NotifyService, translate: TranslateService, router: Router, route: ActivatedRoute, private sidebar: SidebarService, @Inject('BASE_URL') public baseUrl: string) {
        super(auth, http, httpClient, helper, notify, translate, router, route, baseUrl);

        this.requestStatusDefault = "4";
        this.pathCode = 3;
    }

    ngOnInit() {
        this.init();
        this.onSearch();
        this.sidebar.getSiteMapByUrlNew(this.auth.GroupUserCode);
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subsNotify.unsubscribe();
    }

    onSearch() {
        let params = new UrlParams();
        params.addDate('fromDate', this.fromDate);
        params.addDate('toDate', this.toDate);
        params.add('requestTypes', Util.array2String1(this.requestTypesSelected, ';'), '');
        params.add('requestStatus', this.requestStatusDefault, '');
        params.add('custSearch', this.keywordCustomerSearch, '');
        params.add('scSearch', this.keywordSCSearch, '');
        params.add('requestCode', this.requestCodeSearch, '');
        params.add('userName', this.auth.LoginUser, '');
        params.add('userType', this.auth.GroupUserCode, '');
        params.add('area', Util.array2String1(this.areaSelected, ','), '');

      
        this.data = this.http.getByManager(`api/Request/SearchRequestForAll/${params.toString()}`, this.auth);
        this.initParamSearch();
    }

    onClearSearch() {
        this.requestStatusSelected = this.requestStatusDefault;
        //this.requestTypeSelected = null;
        this.fromDate = null;
        this.toDate = null;
        this.keywordCustomerSearch = null;
        this.keywordSCSearch = null;
        this.requestCodeSearch = null;
        this.requestTypesSelected = [];
        this.areaSelected = [];
        this.checkAreaMList = false;
        this.checkRequestTypeMList = false;
        this.onSearch();
    }

    onCheckAllRequestType(evt: ChangeEventArgs) {
        this.enableRequestTypeList = true;//!evt.checked;

        if (evt.checked) {
            this.requestTypesSelected = [];
            this.checkRequestTypeMList = true;
            this.requestTypeMList.forEach(p => {
                this.requestTypesSelected.push(p.Value);
            });
        } else {
            this.requestTypesSelected = [];
            this.checkRequestTypeMList = false;
        }
        //this.ngRefresh();
    }

    onCheckAllArea(evt: ChangeEventArgs) {
        this.enableAreaList = true;//!evt.checked;

        if (evt.checked) {
            this.areaSelected = [];
            this.checkAreaMList = true;
            this.areaMList.forEach(p => {
                this.areaSelected.push(p);
            });
        } else {
            this.areaSelected = [];
            this.checkAreaMList = false;
        }
    }

    onActionBegin(evt: any) {
    }
}

